import CabinTypeInput from "../../../components/CabinTypeInput";
import CardTypeInput from "../../../components/CardTypeInput";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import HeaderBread from "../../../components/HeaderBread";
import Layout from "../../../Layout";

const CreateCardType = () => {
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Card Type",
      route: "/website/loyalty/card-types",
    },
    {
      title: "Add Card Type",
      route: "/website/loyalty/card-types/add",
    },
  ];

  return (
    <Layout type={"create_per"} module_data={"Card Type"}>
      <CustomHeaderTitle title={"Create Card Type"} />
      <HeaderBread
        navigation={navigation}
        title={"Add Card Type"}
      ></HeaderBread>
      <CardTypeInput cardtype={{}} />
    </Layout>
  );
};

export default CreateCardType;
